import React from "react";
import styles from "./HighlightedOutput.module.scss";
// Stage 0: ₀ or 0. Stage 1: ₁ or 1.
var STAGE0 = "[₀0]";
var STAGE1 = "[₁1]";
function tokenize(str) {
    var tokens = [];
    var i = 0;
    while (i < str.length) {
        var rest = str.slice(i);
        // Whitespace (preserve newlines and indentation)
        var wsMatch = rest.match(/^(\s+)/);
        if (wsMatch) {
            tokens.push({ type: "whitespace", value: wsMatch[1] });
            i += wsMatch[1].length;
            continue;
        }
        // Keywords (whole words)
        var kwMatch = rest.match(/^(const|let|in)\b/);
        if (kwMatch) {
            tokens.push({ type: "keyword", value: kwMatch[1] });
            i += kwMatch[1].length;
            continue;
        }
        // Types with stage: Nat₀, Nat₁, Nat0, Nat1, U₀, zero₁, succ₀, nat_elim₁, etc.
        // Use (?!\w) instead of \b - Unicode subscripts ₀₁ are not word chars, so \b fails
        var type0Match = rest.match(new RegExp("^(Nat|U|zero|succ|nat_elim)" + STAGE0 + "(?!\\w)"));
        if (type0Match) {
            tokens.push({ type: "type0", value: type0Match[0] });
            i += type0Match[0].length;
            continue;
        }
        var type1Match = rest.match(new RegExp("^(Nat|U|zero|succ|nat_elim)" + STAGE1 + "(?!\\w)"));
        if (type1Match) {
            tokens.push({ type: "type1", value: type1Match[0] });
            i += type1Match[0].length;
            continue;
        }
        // Literals with stage: 2₁, 1₁ (stage 1) vs 0₀ (stage 0). Also 2_1, 1_0 format.
        var literal1Match = rest.match(/^(\d+[₁1]|\d+_1)/);
        if (literal1Match) {
            tokens.push({ type: "literal1", value: literal1Match[1] });
            i += literal1Match[1].length;
            continue;
        }
        var literal0Match = rest.match(/^(\d+[₀0]|\d+_0)/);
        if (literal0Match) {
            tokens.push({ type: "literal0", value: literal0Match[1] });
            i += literal0Match[1].length;
            continue;
        }
        // Plain numbers (no subscript) - treat as stage 0
        var plainNumMatch = rest.match(/^(\d+)/);
        if (plainNumMatch) {
            tokens.push({ type: "literal0", value: plainNumMatch[1] });
            i += plainNumMatch[1].length;
            continue;
        }
        // Multi-char operators (check before single-char)
        if (rest.startsWith("=>")) {
            tokens.push({ type: "operator", value: "=>" });
            i += 2;
            continue;
        }
        if (rest.startsWith("->")) {
            tokens.push({ type: "operator", value: "->" });
            i += 2;
            continue;
        }
        // Single-char operators
        if (/[~^⇑<>=:]/.test(rest[0])) {
            tokens.push({ type: "operator", value: rest[0] });
            i += 1;
            continue;
        }
        // Punctuation
        if (/[()]/.test(rest[0])) {
            tokens.push({ type: "punctuation", value: rest[0] });
            i += 1;
            continue;
        }
        // Identifiers: (alpha|_)(alpha|digit|_)*
        var idMatch = rest.match(/^([a-zA-Z_][a-zA-Z0-9_]*)/);
        if (idMatch) {
            tokens.push({ type: "identifier", value: idMatch[1] });
            i += idMatch[1].length;
            continue;
        }
        // Fallback: single character
        tokens.push({ type: "text", value: rest[0] });
        i += 1;
    }
    return tokens;
}
export function HighlightedOutput(_a) {
    var children = _a.children, className = _a.className, dataErr = _a["data-err"];
    var tokens = tokenize(children);
    return (React.createElement("div", { className: styles.result + " " + (className !== null && className !== void 0 ? className : ""), "data-err": dataErr }, tokens.map(function (token, i) {
        if (token.type === "whitespace" || token.type === "text") {
            return React.createElement("span", { key: i }, token.value);
        }
        return (React.createElement("span", { key: i, className: styles[token.type] }, token.value));
    })));
}
